import FormLabelInput from "../labels/form.label.input";

const FormDatePickerInput = ({ className, ...otherProps }) => {
  return (
    <div className={`${className ? className : "w-full"}`}>
      <FormLabelInput>{otherProps.label}:</FormLabelInput>
      <input
        type="date"
        {...otherProps}
        className="w-full text-secondary shadow focus:shadow-primary px-4 py-2 font-ubuntuMedium rounded flex justify-end focus:outline-none"
      />
    </div>
  );
};

export default FormDatePickerInput;
